import { defineComponent } from 'vue';
export default defineComponent({
    name: 'OkkiTableColumnGroup',
    slots: ['title'],
    __ANT_TABLE_COLUMN_GROUP: true,
    render() {
        return null;
    },
});
